import { useCallback } from 'react'
import { BestContactMethodOptionsType } from './useData'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'

export function useHandlers({ name }) {
  const { setFieldValue } = useFormikContext<IAddOpportunityFormModel>()

  const handelChange = useCallback(
    (value: BestContactMethodOptionsType | null) => {
      setFieldValue(name, value?.value)
    },
    [],
  )

  return {
    handelChange,
  }
}
